import chatgpt from '../../assets/marks/chatgpt.svg';
import claude from '../../assets/marks/claude.svg';
import cursor from '../../assets/marks/cursor.svg';
import facebook from '../../assets/marks/facebook.svg';
import gemini from '../../assets/marks/gemini.svg';
import grok from '../../assets/marks/grok.svg';
import hermesAgent from '../../assets/marks/hermes-agent.svg';
import instagram from '../../assets/marks/instagram.svg';
import linkedin from '../../assets/marks/linkedin.svg';
import n8n from '../../assets/marks/n8n.svg';
import openclaw from '../../assets/marks/openclaw.svg';
import threads from '../../assets/marks/threads.svg';
import tiktok from '../../assets/marks/tiktok.svg';
import x from '../../assets/marks/x.svg';
import youtube from '../../assets/marks/youtube.svg';
import { cn } from '../../lib/utils';
import { assetUrl } from './asset-url';

/** Figma Mark/* (platforms) and Mark / * (agents), exported as-is. */
const MARKS = {
  tiktok,
  instagram,
  youtube,
  facebook,
  x,
  linkedin,
  threads,
  claude,
  chatgpt,
  grok,
  gemini,
  'hermes-agent': hermesAgent,
  openclaw,
  cursor,
  n8n,
} as const;

export type BrandMarkName = keyof typeof MARKS;

/** Every mark, platforms first then agents (Figma order). */
export const BRAND_MARK_NAMES = Object.keys(MARKS) as BrandMarkName[];

export type BrandMarkProps = {
  name: BrandMarkName;
  /** Rendered size in px (square). Default 24, the Figma size. */
  size?: number;
  className?: string;
  /**
   * Accessible name. Omit when a visible label sits next to the mark - it is
   * then decorative (`alt=""`, aria-hidden).
   */
  title?: string;
};

/**
 * Third-party brand mark (Figma: Onboarding Screens ↳ Platform marks, Landing
 * Page ↳ Agents). SVGs are the Figma exports: brand colours are intentional,
 * don't recolour them.
 */
export function BrandMark({ name, size = 24, className, title }: BrandMarkProps) {
  return (
    <img
      data-slot="brand-mark"
      data-name={name}
      src={assetUrl(MARKS[name])}
      width={size}
      height={size}
      alt={title ?? ''}
      aria-hidden={title ? undefined : true}
      decoding="async"
      className={cn('shrink-0', className)}
    />
  );
}
